'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidOptions = function IoAndroidOptions(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm0 32.5v-2.5h21.3v2.5h-21.3z m28.8 0v-2.5h6.2v2.5h-6.2z m-1.3 2.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-7.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v7.5z m-27.5-13.7v-2.5h6.3v2.5h-6.3z m13.8 0v-2.5h21.2v2.5h-21.2z m-1.3 2.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-7.5c0-1.5 1.1-2.5 2.5-2.5s2.5 1 2.5 2.5v7.5z m-12.5-13.8v-2.5h21.3v2.5h-21.3z m28.8 0v-2.5h6.2v2.5h-6.2z m-1.3 2.5c0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5v-7.5c0-1.4 1.1-2.5 2.5-2.5s2.5 1.1 2.5 2.5v7.5z' })
        )
    );
};

exports.default = IoAndroidOptions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-options.js
// module id = 2122
// module chunks = 0